import { render, staticRenderFns } from "./QuestionBlank.vue?vue&type=template&id=5738f6d8&scoped=true&"
import script from "./QuestionBlank.vue?vue&type=script&lang=js&"
export * from "./QuestionBlank.vue?vue&type=script&lang=js&"
import style0 from "./QuestionBlank.vue?vue&type=style&index=0&id=5738f6d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5738f6d8",
  null
  
)

export default component.exports